<template>
  <section class="w-100">
    <LmButton
      size="sm"
      value="Condicionales"
      v-b-toggle.conditional-builder
    />
    <b-collapse id="conditional-builder" :visible="isVisible">
      <b-card class="border">
        <Group
          :nodes="query"
          :union="queryUnion"
          @node-add="onNodeAdd"
          @node-remove="onNodeRemove"
          @group-add="onGroupAdd"
          @group-remove="onGroupRemove"
          :noGroups="noGroups"
          :maxConditions="maxConditions"
          :conditionalsData="conditionalsData"
        />
      </b-card>
    </b-collapse>
  </section>
</template>

<script>
// Components
import Group from '@/components/lmConditionalBuilder/components/Group.vue'
import LmButton from '@/components/form/elements/LmButton'

// Utils
import { nanoid } from 'nanoid'
import commonsApi from '@/api/commons'

export default {
  name: 'LmConditionalBuilder',
  components: {
    Group,
    LmButton
  },
  props: {
    maxConditions: {
      type: Number,
      default: null
    },
    noGroups: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      queryUnion: {
        value: {
          id: 'AND',
          name: 'todas'
        }
      },
      query: [],
      conditionalsData: {}
    }
  },
  computed: {
    build () {
      return this.generateQuery(this.query, this.queryUnion)
    },
    conditionals () {
      if (this.query.length) {
        return {
          queryUnion: this.queryUnion,
          query: this.query
        }
      }
      return null
    },
    isVisible () {
      if (!this.value || !this.query.length) {
        return false
      }
      return true
    }
  },
  methods: {
    generateQuery (data, union) {
      let build = ''
      data.forEach((el, index) => {
        if (el?.type === 'condition') {
          build += ` ${el.expression?.id} ${el.validation?.id} ${el.value?.id} `
        }
        if (index < data.length - 1) {
          build += ` ${union.value.id} `
        }
        if (el?.children && el?.children?.length) {
          const group = this.generateQuery(el.children, el.union)
          build += `${group}`
        }
      })
      return `(${build})`
    },
    onNodeAdd (event) {
      event.nodes.push({
        id: nanoid(5),
        type: 'condition',
        expression: '',
        validation: '',
        value: ''
      })
    },
    onNodeRemove (event) {
      const index = event.nodes.findIndex(el => el.id === event.id)
      event.nodes.splice(index, 1)
    },
    onGroupAdd (event) {
      event.nodes.push({
        id: nanoid(5),
        union: {
          value: {
            id: 'OR',
            name: 'al menos una'
          }
        },
        children: []
      })
    },
    onGroupRemove (event) {
      function filter (data, id) {
        const r = data.filter(item => {
          if (item.children) {
            item.children = filter(item.children, id)
          }
          return item.id !== id
        })
        return r
      }
      this.query = filter(this.query, event)
    }
  },
  watch: {
    value: {
      inmediate: true,
      deep: true,
      handler (val) {
        if (val !== null) {
          this.query = val.query
          this.queryUnion = val.queryUnion
        }
      }
    }
  },
  async created () {
    try {
      const { data } = await commonsApi.axiosGetWrapper(`/conditionalsbuilder/${this.view}/all/`)
      this.conditionalsData = data

      if (this.value !== null) {
        this.query = this.value.query
        this.queryUnion = this.value.queryUnion
      }
    } catch (error) {
      console.log(error)
    }
  }
}
</script>
